import React, { createContext, useEffect, useState } from 'react';
import useMyMApi from '../hooks/useMyMApi';
import { MyMProgress } from '../ui-elements/MyMProgress';

export const PageResourceContext = createContext({});

export const PageResourceContextProvider = (props) => {

  const [isLoaded, setIsLoaded] = useState(false);
  const [pageResource, setPageResource] = useState({
    ControlSettings: {},
    MessageList: [],
  });
  const apiRequest = useMyMApi("MyM000");

  useEffect(() => {

    const callbackRequestPageContext = (result) => {
      if (result) {
        pageResource.MessageList = result.MessageList;
        pageResource.ScreenSettings = result.ScreenSettings;
        // 2024.9.16 MyMine Version2.0対応 Add Start
        pageResource.CommonFiles = result.CommonFiles;
        // 2024.9.16 MyMine Version2.0対応 Add End
        for (var controlSettingsData of result.ControlSettingList) {
          const labelList = controlSettingsData.LabelList;
          const imageList = controlSettingsData.ImageList;
          // 2024.9.16 MyMine Version2.0対応 Add Start
          const urlList = controlSettingsData.UrlList;
          const styleList = controlSettingsData.StyleList;
          // 2024.9.16 MyMine Version2.0対応 Add End
          pageResource.ControlSettings[controlSettingsData.ScreenId] =
          {
            LabelList: labelList,
            ImageList: imageList,
            // 2024.9.16 MyMine Version2.0対応 Add Start
            UrlList: urlList,
            StyleList: styleList,
            // 2024.9.16 MyMine Version2.0対応 Add End
          };
        }
        setPageResource(pageResource);

      }
      setIsLoaded(true);
    }

    const requestFailed = (result) => {
      setIsLoaded(true);
    }

    apiRequest.requestJson('api/page/page-context', 'GET', callbackRequestPageContext, requestFailed)
  }, []);

  if (!isLoaded)
    return <MyMProgress />;

  return (
    <PageResourceContext.Provider value={pageResource}>
      {props.children}
    </PageResourceContext.Provider>
  );
};